import MediaLibrarySearchLink from './media-library/search-link';
import { fetchSnippetsForProductNumberList, prepareSnippetsForDOMInsertion } from './product-snippets';
import { getTranslation } from './utilities';
const mediaLibrarySearchLink = new MediaLibrarySearchLink;

const mainCategories = ['20.00.00.00', '21.00.00.00', '22.00.00.00', '23.00.00.00'];

const internalFilterNameMapping = {
    'Novelties': 'novelties',
    'PrivateBrand': 'private-brand',
    '20.00.00.00': 'lingerie-and-fashion',
    '21.00.00.00': 'toys',
    '22.00.00.00': 'fetish',
    '23.00.00.00': 'sex-drugstore'
};

const externalFilterNameMapping = {
    'novelties': 'Novelties',
    'private-brand': 'PrivateBrand',
    'lingerie-and-fashion': '20.00.00.00',
    'toys': '21.00.00.00',
    'fetish': '22.00.00.00',
    'sex-drugstore': '23.00.00.00'
};

const tagsContainer = document.querySelector('.js-overlay-category-overview-tags');
const privateLabelTag = document.querySelector('.js-overlay-category-overview-private-label');
const productsSection = document.querySelector('.js-overlay-category-overview__new-products--section');
const productsContainer = document.querySelector('.js-overlay-category-overview__new-products--container');

let abortController = null;
let currentRequestId = 0;

// Welches Label wurde geklickt
function initOverlayCategoryOverview()
{
    let anchors = document.querySelectorAll('.js-overlay-category-overview');
    anchors.forEach(function(anchor)
    {
        anchor.addEventListener('click', handleCategoryClick);
    });
}

// Event-Handler für Klick auf Label
function handleCategoryClick()
{
    const listElement = this.closest('li');
    let labelContainer = this.closest('a');
    let labelTitle = labelContainer.getAttribute('data-label-title');
    let linkML = document.querySelector('.js-media-library__search-link');
    let linkProducts = document.querySelector('.js-overlay-category-overview-products-link');

    updateOverlayTitle(labelTitle);
    if (window.innerWidth >= 960 && document.querySelector('body').classList.contains('authorized')) // Nur Desktop & autorisiert
    {
        handleMLLink(linkML, labelTitle);
    }
    handleProductLink(linkProducts, labelTitle);
    updateTags(listElement);
    fetchOverlayProducts(labelTitle);
}

function fetchOverlayProducts(labelName)
{
    if (abortController) abortController.abort();

    abortController = new AbortController();

    const requestId = ++currentRequestId;

    productsSection.classList.add('hidden');

    productsContainer.innerHTML = '';

    fetchLabelNoveltiesProductNumberList(labelName).then(response => response.json()).then(productNumberList =>
    {
        if (productNumberList.length)
        {
            fetchSnippetsForProductNumberList(productNumberList, 3, abortController.signal)
                .then(response => response.json()).then(snippets =>
                {
                    if (requestId !== currentRequestId) return;

                    productsContainer.innerHTML = '';

                    for (const snippet of snippets[0].snippets)
                    {
                        if (requestId !== currentRequestId) break;

                        const element = prepareSnippetsForDOMInsertion(snippet);

                        productsContainer.appendChild(element);
                    }

                    if (snippets[0].snippets.length)
                    {
                        productsSection.classList.remove('hidden');
                    }
                })
                .catch(error => console.log(error));
        }
    });
}

function fetchLabelNoveltiesProductNumberList(labelName)
{
    return fetch(
        '/api-product-search?q=labelNameFacet:"' + labelName + '"&sort=sortByNoveltyTimestamp desc&rows=3'
        + '&fq_collapse={!tag=collapse}{!collapse field=solrProductGroupId_DE sort=\'score desc\'}'
    );
}

// Aktualisiert Titel im Overlay
function updateOverlayTitle(labelTitle)
{
    let titleElement = document.querySelector('.js-overlay-category-overview-title');
    if (titleElement)
    {
        titleElement.innerHTML = labelTitle;
    }
}

// Aufbau Produktlink
function handleProductLink(linkProducts, labelTitle)
{
    if (linkProducts)
    {
        let [baseHrefProducts] = linkProducts.getAttribute('href').split('?');
        linkProducts.setAttribute('href',
            `${baseHrefProducts}?q=--0--24----labelNameFacet%3A%3A"${labelTitle}"&last=labelNameFacet`);
    }
}

// Aufbau ML-Link
function handleMLLink(linkML, labelTitle)
{
    let [baseHrefML] = linkML.getAttribute('href').split('?');
    linkML.dataset.mlSearchValue = labelTitle;
    linkML.setAttribute('href', `${baseHrefML}?searchTerm=${labelTitle}`);

    mediaLibrarySearchLink.init(linkML);
}

// Aktualisiert Private Label im Overlay
function updateTags(listElement)
{
    tagsContainer.innerHTML = '';

    const flags = listElement.dataset.flagsString ? listElement.dataset.flagsString.split(',') : null;
    const categories = listElement.dataset.categoriesString ? listElement.dataset.categoriesString.split(',') : null;

    if (flags && flags.includes('PrivateBrand'))
    {
        tagsContainer.append(privateLabelTag);
    }

    if (categories)
    {
        const matchingCategories = categories.filter(category => mainCategories.includes(category));

        matchingCategories.forEach(category =>
        {
            const tagElement = document.createElement('span');
            tagElement.classList.add('category-tag');
            tagElement.innerHTML = getTranslation('category.label') + ': ' + getTranslation(category);

            tagsContainer.append(tagElement);
        });
    }
}

// Grid (Switch) Buttons
function initBrandsList()
{
    let labelList = document.getElementById('brands-list');

    let labelListClass = labelList.classList.contains('logo-view') ? 'logo-view' : 'text-view';

    document.querySelectorAll('.js-label-view').forEach(button =>
    {
        button.addEventListener('click', e =>
        {
            e.preventDefault();

            let c = button.getAttribute('data-bind');

            if (c)
            {
                labelList.classList.replace(labelListClass, c);
                labelListClass = c;
            }

            document.querySelectorAll('.js-label-view').forEach(btn =>
            {
                btn.classList.remove('secondary');
                btn.classList.add('tertiary');
            });

            button.classList.add('secondary');
            button.classList.remove('tertiary');
        });
    });
}

function initOverlayEvents()
{
    document.querySelector('body').addEventListener('authorized focus-overlay-clicked', () =>
    {
        document.querySelector('.js-media-library__search-link').classList.add('hidden');
    });

    document.querySelector('#overlay-brand-information').addEventListener('click', e =>
    {
        const closeButton = e.target.closest('a.close');

        if (closeButton && document.querySelector('body').classList.contains('authorized'))
        {
            document.querySelector('.js-media-library__search-link').classList.add('hidden');
        }
    });
}

/**
 * @param {string} filterName
 * @param {boolean} isActive
 */
function handleFilters(filterName, isActive)
{
    const filters = document.querySelectorAll('.js-category-overview__filter');
    const items = document.querySelectorAll('.js-category-overview__filter-item');
    const sections = document.querySelectorAll('.js-category-overview__section');
    const alphabet = document.querySelectorAll('.js-category-overview__alphabet-item');
    const tags = document.querySelectorAll('.js-category-overview__filter-tag');

    const filteredSections = [];

    if (isActive)
    {
        filters.forEach(filter =>
        {
            if (filter.value !== filterName)
            {
                filter.closest('.js-category-overview__filter-container').classList.add('disabled');
            }
        });

        items.forEach(item =>
        {
            const flags = item.dataset.flagsString ? item.dataset.flagsString.split(',') : null;
            const categories = item.dataset.categoriesString ? item.dataset.categoriesString.split(',') : null;

            if ((!flags || !flags.includes(filterName)) && (!categories || !categories.includes(filterName)))
            {
                item.classList.add('hidden');
            }
        });

        sections.forEach(section =>
        {
            const visibleItems = section.querySelector('.js-category-overview__filter-item:not(.hidden)');

            if (!visibleItems)
            {
                section.classList.add('hidden');

                filteredSections.push(section.dataset.alphabetLetter);
            }
        });

        alphabet.forEach(letter =>
        {
            if (filteredSections.includes(letter.dataset.alphabetLetter))
            {
                letter.classList.add('disabled');
            }
        });

        tags.forEach(tag =>
        {
            if (tag.dataset.filterName === filterName) tag.classList.remove('hidden');
        });
    }
    else
    {
        filters.forEach(filter =>
        {
            filter.closest('.js-category-overview__filter-container').classList.remove('disabled');

            filter.checked = false;
        });

        items.forEach(item => item.classList.remove('hidden'));

        sections.forEach(section => section.classList.remove('hidden'));

        alphabet.forEach(letter => letter.classList.remove('disabled'));

        tags.forEach(tag => tag.classList.add('hidden'));
    }

    setUrlParam(filterName, isActive);
}

function initFilterEvents()
{
    document.querySelectorAll('.js-category-overview__filter').forEach(filter =>
    {
        filter.addEventListener('click', () =>
        {
            handleFilters(filter.value, filter.checked);
        });
    });

    document.querySelectorAll('.js-category-overview__filter-tag').forEach(tag =>
    {
        tag.addEventListener('click', () =>
        {
            handleFilters('', false);
        });
    });
}

/**
 * @param {string} filterName
 * @param {boolean} isActive
 */
function setUrlParam(filterName, isActive)
{
    let url = window.location.pathname;

    if (isActive)
    {
        let param = new URLSearchParams();

        param.set('filter', internalFilterNameMapping[filterName]);

        url += '?' + param.toString();
    }

    history.replaceState({}, '', url);
}

function handleUrlParam()
{
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (params.has('filter'))
    {
        const filterName = externalFilterNameMapping[params.get('filter')];
        const filter = document.querySelector(`.js-category-overview__filter[value="${filterName}"]`);

        handleFilters(filterName, true);

        filter.checked = true;
    }
}

if (document.querySelector('body').id === 'category-overview')
{
    initOverlayCategoryOverview();
    initBrandsList();
    initOverlayEvents();
    initFilterEvents();
    handleUrlParam();
}
